export const dimension = 'creative';

export default {};
